!function ($, global) {
    'use strict';

    var $document = $(global.document);

    var DATA_NAME = 'bsx-modal-open-fixed';
    var SELECTOR_BASE = '.modal-open .' + DATA_NAME + '-';

    $document
        .one('show.bs.modal', '.modal', function (event) {
            if (!$document.data(DATA_NAME)) {
                var value = $(event.currentTarget).data('bs.modal')._getScrollbarWidth();
                var styles = $.map(['right', 'margin-right', 'padding-right'], function (property) {
                    var mod = $.map(property.split('-'), function (word) {
                        return word[0]
                    }).join('');

                    return SELECTOR_BASE + mod + '{' + property + ':' + value + 'px!important}';
                }).join('');

                $document.data(DATA_NAME, $('<style>').text(styles).appendTo('head'));
            }
        });

}(jQuery, window);